import { RevealTitle, FadeIn } from "./Reveal";

export const MusicSection = ({ music, texts }) => (
  <section data-testid="music-section" className="relative z-10 py-24 md:py-40 px-6 md:px-12 lg:px-24 bg-[#0A0A0A]">
    <p className="text-[#525252] tracking-[0.5em] text-xs uppercase mb-3">— Sanatçı Kimliği</p>
    <RevealTitle testId="music-title" className="font-blackletter text-4xl sm:text-5xl lg:text-6xl text-[#EDEDEA] mb-12">
      {texts.music_title || "Müzik"}
    </RevealTitle>
    <div className="grid lg:grid-cols-3 gap-10 items-start">
      <FadeIn className="lg:col-span-2">
        <div className="border border-[#8B0000]/40 p-1.5 bg-[#141414]" data-cursor="İZLE">
          <div className="relative w-full" style={{ paddingBottom: "56.25%" }}>
            <iframe
              data-testid="music-embed"
              className="absolute inset-0 w-full h-full"
              src={music.video_url}
              title={music.title || "Nerdeydin"}
              loading="lazy"
              allow="accelerometer; encrypted-media; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      </FadeIn>
      <FadeIn delay={0.2}>
        <h3 className="text-xl md:text-2xl font-semibold text-[#EDEDEA]">{music.title}</h3>
        <p className="mt-2 text-[#C1121F] font-semibold">{music.views}</p>
        <div className="mt-8 border border-[#262626] bg-[#111111] p-6">
          <p className="text-sm text-[#A3A3A3] leading-relaxed">{texts.music_note}</p>
        </div>
      </FadeIn>
    </div>
  </section>
);
